var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "arrow_back_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#arrow_back_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F5148E",
  d: "m7.826 13 4.9 4.9c.2.2.296.434.287.7-.008.267-.112.5-.312.7-.2.184-.434.28-.7.288a.916.916 0 0 1-.7-.287l-6.6-6.6a.878.878 0 0 1-.213-.325A1.107 1.107 0 0 1 4.426 12c0-.134.02-.259.062-.375a.877.877 0 0 1 .213-.325l6.6-6.6a.933.933 0 0 1 .687-.275c.275 0 .513.091.713.275.2.2.3.437.3.712 0 .275-.1.513-.3.713L7.826 11H19c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.712a.968.968 0 0 1-.712.288H7.826Z"
}))));
export default SvgArrowBack;